"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AppointmentCancelContainer_1 = __importDefault(require("./components/AppointmentCancelContainer"));
const getInitialContext_1 = __importDefault(require("./stateMachine/getInitialContext"));
const main_1 = require("./stateMachine/machines/main");
const useManageAppointmentContext_1 = __importDefault(require("../ManageAppointment/hooks/useManageAppointmentContext"));
const getDevLogger = () => {
    if (process.env.NODE_ENV !== 'development') {
        return () => {
            // Intentionally left empty as no operation is needed in non-development environments
        };
    }
    return (state) => {
        /*eslint-disable no-console */
        console.group(`[MachineTransition]: `);
        console.log(state.value, Object.assign({}, state));
        console.groupEnd();
        /*eslint-enable no-console */
    };
};
function AppointmentCancelWidgetV2({ appointment, appointmentId, createRescheduleLink, track, searchProvidersLink, services }) {
    const machine = (0, react_1.useRef)((0, main_1.createAppointmentCancelMachine)(Object.assign(Object.assign({}, (0, getInitialContext_1.default)()), { appointment,
        appointmentId,
        services,
        searchProvidersLink,
        track })));
    return (react_1.default.createElement(useManageAppointmentContext_1.default, { value: {
            config: {
                customerCode: ''
            },
            track
        } },
        react_1.default.createElement(AppointmentCancelContainer_1.default, { createRescheduleLink: createRescheduleLink, logState: getDevLogger(), machine: machine.current })));
}
exports.default = AppointmentCancelWidgetV2;
//# sourceMappingURL=AppointmentCancelWidget.js.map